import * as React from 'react'
import type { SourceDocSourceLoader, SourceDocViewerProps } from './SourceDocViewer'

export type SourceDocRef = {
  /** Job-corpus mode. Omit when using `loadSource`. */
  jobId?: string
  sourceFile: string
  sourcePage?: number
  sourceExcerpt?: string
  /**
   * Optional ambient note for the open (e.g. disposition reason from File
   * Coverage). Omitted by Plant View / structure chips — never required.
   */
  note?: string
  /** When set with `note`, tints the note strip to match a disposition status. */
  noteStatus?: string
  /** Pluggable loader for site-stored (or other non-job) artifacts. */
  loadSource?: SourceDocSourceLoader
  supportsOriginalDownload?: boolean
}

export type UseSourceDocViewerResult = {
  openSource: (args: SourceDocRef) => void
  viewerProps: SourceDocViewerProps
}

/**
 * Owns a single SourceDocViewer dialog so a page can mount many chips that
 * all open the same viewer instance.
 */
export function useSourceDocViewer(): UseSourceDocViewerResult {
  const [open, setOpen] = React.useState(false)
  const [ref, setRef] = React.useState<SourceDocRef>({
    sourceFile: ''
  })

  const openSource = React.useCallback((args: SourceDocRef) => {
    setRef(args)
    setOpen(true)
  }, [])

  return {
    openSource,
    viewerProps: {
      open,
      onOpenChange: setOpen,
      jobId: ref.jobId,
      sourceFile: ref.sourceFile,
      sourcePage: ref.sourcePage,
      sourceExcerpt: ref.sourceExcerpt,
      note: ref.note,
      noteStatus: ref.noteStatus,
      loadSource: ref.loadSource,
      supportsOriginalDownload: ref.supportsOriginalDownload
    }
  }
}
